import { Injectable } from '@angular/core';
import { StorageClassifier } from '../models/interface/storageClassifier.enum';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() {
    /** */
  }

  /**
   * Store a value with a classifier and key into the localStorage
   */
  setValue(classifier: StorageClassifier, key: string, value: string) {
    localStorage.setItem(this.getKey(classifier, key), value);
  }

  /**
   * Get the value store in the localStorage with a classifier and key
   */
  getValue(classifier: StorageClassifier, key: string): string {
    return localStorage.getItem(this.getKey(classifier, key));
  }

  /*
   * Get the key of a value combining classifier and key
   */
  private getKey(classifier: StorageClassifier, key: string): string {
    return `<${classifier}>::${key}`;
  }

  /**
   * remove localStorage keys associate with a classifier
   * @param  {StorageClassifier[]} ...classifiers
   */
  clear(...classifiers: StorageClassifier[]) {
    const len = localStorage.length;
    const keysToDelete = [];
    for (let i = 0; i < len; i++) {
      const key = localStorage.key(i);
      // remove intercom states
      if (key.startsWith('intercom-state')) {
        keysToDelete.push(key);
        continue;
      }
      if (classifiers.find(classifier => key.startsWith(`<${classifier}>::`))) {
        keysToDelete.push(key);
      }
    }
    for (const key of keysToDelete) {
      localStorage.removeItem(key);
    }
  }

  /**
   * Remove a value store in localStorage
   *
   * @param  {StorageClassifier} classifier
   * @param  {string} key
   */
  removeValue(classifier: StorageClassifier, key: string) {
    localStorage.removeItem(this.getKey(classifier, key));
  }
}
